import keyBy from 'lodash-es/keyBy';
import { AddressActionKeys as keys } from './addressActionKeys';
import { AddressTypes } from './addressActionTypes';
import { IAddress } from './addressInterfaces';

export interface IAddressState {
  hash: { [index: number]: IAddress };
  savingIds: number[];
}

const initialState: IAddressState = {
  hash: {},
  savingIds: []
};

export function addressReducer(state: IAddressState = initialState, action: AddressTypes): IAddressState {
  switch (action.type) {
    case keys.SET_ADDRESSES:
      return {
        ...state,
        hash: {
          ...state.hash,
          ...keyBy(action.payload, (a: IAddress) => a.addressId)
        }
      };
    case keys.TOGGLE_ADDRESS_SAVING:
      return {
        ...state,
        savingIds: state.savingIds.includes(action.payload.addressId)
          ? state.savingIds.filter(x => x !== action.payload.addressId)
          : [...state.savingIds, action.payload.addressId]
      };
    default:
      return state;
  }
}
